// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PublishingModal__modal___wigWo {
    --dialog-modal-button-width: 15rem;

    width: 35rem;
    min-height: -moz-min-content;
    min-height: min-content;
}
`, "",{"version":3,"sources":["webpack://./src/components/Publishing/PublishingModal.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;;IAElC,YAAY;IACZ,4BAAuB;IAAvB,uBAAuB;AAC3B","sourcesContent":[".modal {\n    --dialog-modal-button-width: 15rem;\n\n    width: 35rem;\n    min-height: min-content;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `PublishingModal__modal___wigWo`
};
export default ___CSS_LOADER_EXPORT___;
